module.exports = __webpack_public_path__ + "static/media/SimpleTemplate.9ede15b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/SimpleTemplate.pdf
// module id = 3836
// module chunks = 0